var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.inputContainerClass},[_c('v-text-field',{attrs:{"label":_vm.label,"placeholder":_vm.placeHolder},on:{"input":function($event){return _vm.handleInput(_vm.content)}},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }